module.exports = __webpack_public_path__ + "img/Barlow-ExtraLight.1631b047.svg";